export default  {
    component: 'annunciator_param',
    name: 'annunciator_param',
    fields: [
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Role',
            param: 'role',
            type: 'text',
            description: `We need to add 3 types of roles:
            - **user** 
            - **admin** 
            - **super-admin**`
          },
          {
            name: 'Module',
            param: 'module',
            type: 'text',
            description: `Their are 2 options for module:
            - **live** 
            - **analytics**
            We need to add module for each roles`
          },
          {
            name: 'Parameters',
            param: 'parameters',
            type: 'text',
            description: `Option for parameters are displayed as follows::
            - **live** [Parameter Options : oc_ef_trip, tf_wti_trip, tf_oti_trip, tf_bchlz_trip, tf_wti_alarm, tf_oti_alarm, tf_bchlz_alarm, master_trip, uv_ov_trip, molg_alarm]
            - **analytics** [Parameter Options : oc_ef_trip, tf_wti_trip, tf_oti_trip, tf_bchlz_trip, tf_wti_alarm, tf_oti_alarm, tf_bchlz_alarm, master_trip, uv_ov_trip, molg_alarm]`
          }
    ]
  }
